<script lang="ts">
	import { fly } from 'svelte/transition';

	export let withShadow = true;
	export let rounded: 'small' | 'large' = 'small';

	let className = '';
	export { className as class };
</script>

<div
	class="relative rounded-lg {className}"
	class:shadow-lpg-tile={withShadow}
	class:rounded-lg={rounded === 'small'}
	class:rounded-3xl={rounded == 'large'}
	in:fly
>
	<slot />
</div>
